export interface IPageParams {
  current?: number;
  pageSize?: number;
  [key: string]: any;
}

export interface IPageResult {
  status: number;
  msg: string;
  content: any;
}

export const checkResultStatus = (status?: number) => {
  return [200, 20000].includes(status || 0);
};

export const adaptPageParams = (
  { current, page, ...params }: IPageParams = {},
  sortParams: IPageParams = {},
) => {
  const result: { [k: string]: any } = { firstPageIndex: 0, ...params };
  if (current) {
    result.pageIndex = current - 1;
  } else if (page) {
    result.pageIndex = page - 1;
  }
  for (const key in sortParams) {
    if (sortParams[key] === 'ascend') {
      if (!result.sortOrder) {
        result.sortOrder = {};
      }
      result.sortOrder[key] = 'asc';
    } else if (sortParams[key] === 'descend') {
      if (!result.sortOrder) {
        result.sortOrder = {};
      }
      result.sortOrder[key] = 'desc';
    }
  }
  return result;
};

export const adaptPageResult = (res: IPageResult) => {
  return {
    data: res.content?.content || res.content?.data || res.content,
    success: checkResultStatus(res.status),
    total: res.content?.page?.totalElements || res.content?.total || res.content?.totalElements,
  };
};
